import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	activatedBannerText: {
		id: 'jira.dashboard.engagement.banner.activated.text',
		defaultMessage:
			'You now have access to our <a>new dashboards in Atlassian Home</a>. <b>Try them out today</b>.',
		description: 'Banner text announcing Home Dashboards are now available',
	},
	dismissButtonText: {
		id: 'jira.dashboard.try-home-dashboards-banner.banner.dismiss.button.text',
		defaultMessage: 'Dismiss',
		description: 'Text for the dismiss button',
	},
});
